import React from "react";
import { Label, FormGroup, Input, Progress } from "reactstrap";

const PollOptionComponent = ({
  feed,
  option,
  optionIndex,
  // feedIndex,
  // post
}) => {
  const _getPercentageValue = (feed, option, precision = 0) => {
    if (feed?._opinions?.length && option?.count) {
      return ((option.count * 100) / feed._opinions.length).toFixed(precision);
    }
    return 0;
  };

  const _defaultSelectedPollAnswer = (option) => {
    if (feed?._opinions?.length) {
      let maxCountOption = { count: 0 };
      feed.options.forEach((element) => {
        if (maxCountOption.count < element.count) {
          maxCountOption = element;
        }
      });
      if (option?._id === maxCountOption?._id) {
        return true;
      }
    }
    return false;
  };

  return (
    <FormGroup check className="radio" key={optionIndex}>
      <Label check className="form-check-label">
        <Input
          className="form-check-input"
          type="radio"
          onChange={() => {
            console.log("post, option, feedIndex");
            // only fan selected the options
            // props.selectPollOption(post, option, feedIndex)
          }}
          value={option.text}
          checked={_defaultSelectedPollAnswer(option)}
        />
        <span className="pollOptions">{option.text}</span>
        <>
          <Progress value={_getPercentageValue(feed, option)} />
          <span className="pollPercent">
            {_getPercentageValue(feed, option)}%
          </span>
        </>
      </Label>
    </FormGroup>
  );
};

export default PollOptionComponent;
